import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container, Row, Col} from 'react-bootstrap'
import MenuCandidate from '../components/menus/MenuCandidate'
import Dashboard from '../pages/candidate/Dashboard'
import Report from '../pages/candidate/Report'
import Profile from '../pages/candidate/Profile'
import { HeaderCandidate } from '../components/headers/HeaderCandidate'
import jwtDecode from 'jwt-decode'
import OfficialTitles from '../pages/candidate/OfficialTitles'
import Courses from '../pages/candidate/Courses'
import CareerPath from '../pages/candidate/CareerPath'
import Competences from '../pages/candidate/Competences'
import Technologies from '../pages/candidate/Technologies'
import Methodologies from '../pages/candidate/Methodologies'
import Languages from '../pages/candidate/Languages'
import Tickets from '../pages/candidate/Tickets'
import Config from '../pages/candidate/Config'
import { Footer } from '../components/footers/Footer'
import IdealPosition from '../pages/candidate/IdealPosition'
import ActiveProcesses from '../pages/candidate/ActiveProcesses'
import Process from '../pages/candidate/Process'
import CompletedProcesses from '../pages/candidate/CompletedProcesses'
// import JobPortal from '../pages/candidate/JobPortal'
import RequestsSent from '../pages/candidate/RequestsSent'


export default function CandidateRouter () {
	const navigate = useNavigate()

    useEffect(() => {
		let token = sessionStorage.getItem('jwt')
		let firsttimeSession = sessionStorage.getItem('firsttime')
	
		if (token !== 'undefined') {
			let firsttime = jwtDecode(token).firsttime

			if(firsttime === true && firsttimeSession !== 'false'){
				navigate('/candidate/profile')
			}
		}else{
			navigate('/login')
		}	
    }, [navigate])

	return (
		<Container className='d-lg-flex contenedor'>
			<div className='menu-lateral d-none d-lg-block'>
					<MenuCandidate/>
			</div>
			<div className='contenido'>
				<Row>
					<Col>
						<HeaderCandidate/>
					</Col>
				</Row>
				<Row>
					<Col>
						<Routes>
							<Route path="/dashboard" element={<Dashboard/>}/>							
							<Route path="/profile/officialtitles" element={<OfficialTitles/>}/>
							<Route path="/profile/courses" element={<Courses/>}/>
							<Route path="/profile/careerpath" element={<CareerPath/>}/>
							<Route path='/profile/competences' element={<Competences/>}/>
							<Route path='/profile/technologies' element={<Technologies/>}/>
							<Route path='/profile/methodologies' element={<Methodologies/>}/>
							<Route path='/profile/languages' element={<Languages/>}/>
							<Route path='/profile/ideal-position' element={<IdealPosition/>}/>
							<Route path="/report" element={<Report/>}/>
							<Route path="/profile" element={<Profile/>}/>
							<Route path="/config" element={<Config/>}/>
							<Route path="/tickets" element={<Tickets/>}/>
							<Route path="/active-processes" element={<ActiveProcesses/>}/>
							{/* <Route path="/job-portal" element={<JobPortal/>}/> */}
							<Route path="/completed-processes" element={<CompletedProcesses/>}/>
							<Route path="/requestsSent" element={<RequestsSent/>}/>
							<Route path="/process/:id" element={<Process/>}/>
							<Route path="*" element={<NotFoundPage />}/>
						</Routes>
					</Col>
				</Row>
				<Row>
					<Col>
						<Footer/>
					</Col>
				</Row>
			</div>
		</Container>
	)
}